import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 9.1 — Tour de Reportes.
 * Sprint 48 — Reescrito completo. El tour anterior cubría solo el 30% de la página.
 * Se añaden pasos para ResumenRápido (Sprint 36), métodos de pago, desglose
 * contable y propinas/auditoría.
 */
export const tourReportes: TourDefinition = {
  id: 'reportes',
  title: 'Cómo leer los reportes',
  steps: [
    {
      element: '[data-tour="rpt-fecha"]',
      popover: {
        title: '1. Selector de fecha',
        description:
          'Elige el día que quieres analizar. Por defecto muestra hoy. El ícono de refresco actualiza los datos sin cambiar la fecha.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="rpt-resumen-rapido"]',
      popover: {
        title: '2. Resumen rápido por período',
        description:
          'Vista de comparación: ¿cómo va HOY vs la semana promedio vs el mes? Las barras te dicen de un vistazo si el día está por encima o por debajo de lo habitual. Útil para tomar decisiones en tiempo real.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="rpt-kpis"]',
      popover: {
        title: '3. KPIs del día',
        description:
          'Total de ventas, pedidos cobrados, ticket promedio (cuánto gasta cada cliente en promedio) y meseros activos. Son los 4 indicadores que la dueña revisa primero cada día.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="rpt-metodos-pago"]',
      popover: {
        title: '4. Ventas por método de pago',
        description:
          'Cuánto entró en efectivo, cuánto con tarjeta y cuánto por transferencia. Sirve para cuadrar la gaveta: el efectivo reportado aquí debe coincidir con lo que tienes físicamente.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="rpt-desglose-contable"]',
      popover: {
        title: '5. Desglose contable',
        description:
          'Separación contable del ingreso total: alimentos (subtotal puro), envíos cobrados en caja, envíos contra-entrega (pagados al repartidor, NO entran a la gaveta) e impuesto acumulado. Útil para reportes fiscales.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="rpt-propinas-auditoria"]',
      popover: {
        title: '6. Propinas y auditoría',
        description:
          'Tres métricas de control: propinas del día (acumuladas en el pozo), descuentos aplicados por promociones y artículos cancelados. Si los cancelados son muchos, puede indicar un problema operativo.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="rpt-productos"]',
      popover: {
        title: '7. Platillos y paquetes más vendidos',
        description:
          'Ranking de lo que más se vendió en el día: primero productos individuales, luego paquetes. Útil para planear la compra del día siguiente y saber qué preparar más.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="rpt-meseros"]',
      popover: {
        title: '8. Ventas por mesero',
        description:
          'Cuánto vendió cada mesero durante el día: número de pedidos y total cobrado. Aparece solo si hubo más de un mesero activo. Sirve para calcular comisiones o para identificar quién necesita apoyo.',
        side: 'top',
      },
    },
  ],
};
